import { RouteTypes } from 'consts';
import Header from 'containers/Header';
import Table from 'containers/Table';
import { useList } from 'hooks/list';
import { useEffect } from 'react';
import { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { RfUiBreadcrumbs, RfUiModal } from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  setLoading,
  setModalDraftType,
  setMsgSubmit,
} from 'store/app/actions';
import {
  getInformesInfraestructura,
  getInformesInfraestructuraCount,
  getInformesInfraestructuraExcel,
  setInformesInfraestructuraCount,
} from 'store/informes/actions';
import {
  makeSelectAllInformesCursosFilter,
  makeSelectInformesInfraestructura,
  makeSelectInformesInfraestructuraCount,
} from 'store/informes/selectors';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import {
  getTodayFinishDate,
  getTodayMinusOneMonthStartDate,
  getTodayMinusOneYearStartDate,
} from 'utils/dates-validators';
import { hasAccess } from 'utils/listUtils';
import { formatMinutes } from 'utils/practiceUtils';
import { userProfile } from 'utils/profilesIndex';
import { ReportInfrastructureFilter } from './ReportInfrastructureFilter/ReportInfrastructureFilter';
import { makeSelectModalDraftType, makeSelectMsgSubmit } from 'store/app/selectors';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  access_token: makeSelectTokenAccessToken(),
  msgSubmit: makeSelectMsgSubmit(),
  modalDraftType: makeSelectModalDraftType(),
  cursos: makeSelectInformesInfraestructura(),
  cursosCount: makeSelectInformesInfraestructuraCount(),
  allInformesCursosFilter: makeSelectAllInformesCursosFilter(),
} as any);

export const nomPaginaIHI = 'Informes de Habilitaciones Infraestructura';
const links = [
  {
    label: 'Informes',
    link: '#',
    textHelp: 'Informes',
    active: true,
  },
];

const Courses = (): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    access_token,
    msgSubmit,
    modalDraftType,
    cursos,
    profileActive,
    cursosCount,
    allInformesCursosFilter,
  } = useSelector<any, any>(selectors);
  const redirect = (e: any) => {
    history.push(e.detail);
  };

  const initFilter = {
    elemInicio: 0,
    elemFin: 25,
    elemFinal: 25, // Algunas peticiones cambian el nombre del parámetro
    fechaInicio:
      (profileActive?.ID_PERFIL === '511' || profileActive?.ID_PERFIL === '611' || profileActive?.ID_PERFIL === '711')
        ? getTodayMinusOneMonthStartDate().toString()
        : getTodayMinusOneYearStartDate().toString(),
    fechaFin: getTodayFinishDate(),
    orden: '',
    ascDesc: '',
    sociedades: '',
    estadosCurso: 'IN',
    cursos: '',
    alumnos: '',
    provincias: '',
  };
  const {
    filterRef,
    data,
    setData,
    headers,
    handleFilterTable,
    handleFilterChange,
  } = useList(
    { ...initFilter },
    [
      {
        text: 'Curso',
        orderBy: 'asc',
        ariaLabelIcon: 'Icono de ordenar',
      },
      { text: 'Nombre curso' },
      { text: 'Matrícula Alumno' },
      {
        text: 'Alumno',
        orderBy: 'asc',
        ariaLabelIcon: 'Icono de ordenar',
      },
      {
        text: 'Trayecto',
      },
      // { text: 'Fecha inicio jornada' },

      // { text: 'Hora inicio jornada' },
      // { text: 'Hora fin jornada' },

      { text: 'Pasadas validadas' },
      { text: 'Pasadas pendientes' },

      { text: 'Horas validadas CE' },
      { text: 'Horas pendientes CE' },
      { text: 'Horas validadas OP' },
      { text: 'Horas pendientes OP' },
    ],
    {
      action: (filter) => dispatch(getInformesInfraestructura(filter)),
      headerToAPIMap: {
        Curso: 'ID_CURSO',
        Alumno: 'ID_ALUMNO',
      },
    },
    (filter) => {
      dispatch(setInformesInfraestructuraCount(0));

      dispatch(getInformesInfraestructura(filter));
      dispatch(getInformesInfraestructuraCount(filter));
    },
    async () => {
      dispatch(setLoading(true));
      await new Promise(resolve => setTimeout(resolve, 90));
      dispatch(setLoading(false));
    }
  );

  const handleExportExcel = () => {
    const excelColumns = [...headers];
    dispatch(
      getInformesInfraestructuraExcel({
        filter: { ...filterRef.current },
        excelConfig: {
          literals: [...excelColumns],
        },
      })
    );
  };

  useEffect(() => {
    if (profileActive) {
      dispatch(getInformesInfraestructura(filterRef.current));
      dispatch(getInformesInfraestructuraCount(filterRef.current));
    }
  }, [profileActive]);

  const accessToAlumns = hasAccess(profileActive, [
    userProfile.formador,
    userProfile.gestor,
    userProfile.administrador,
    userProfile.supervisor,
    userProfile.visualizador,
  ]);

  useEffect(() => {
    if (!profileActive || !allInformesCursosFilter.length) {
      return;
    }

    const cursosParsed = cursos.map((item) => {
      const link = accessToAlumns ? '/listado-alumnos/' + item.ID_CURSO : '';

      return {
        table: [
          [
            { text: item.ID_CURSO, urlLink: link },
            {
              text: allInformesCursosFilter.find(
                (curso) => curso.ID_CURSO.toString() === item.ID_CURSO
              )?.NOMBRE_CURSO,
            },
            { text: item.ID_ALUMNO },
            { text: item.nombre_parsed },
            { text: item.TRAYECTO },
            // { text: parseDate(new Date(Number(item.FECHA_INI_JORNADA))) },
            // { text: hourFormat(item.HORA_INI_JORNADA) },
            // { text: hourFormat(item.HORA_FIN_JORNADA) },

            { text: item.TRAYECTO_VALIDADO.toString() },
            { text: item.TRAYECTO_PENDIENTE_VALIDAR.toString() },

            {
              text: formatMinutes(
                item.HORAS_VALIDADAS_CONDUCCION_EFECTIVA.toString()
              ),
            },
            {
              text: formatMinutes(
                item.HORAS_PENDIENTES_VALIDAR_CONDUCCION_EFECTIVA.toString()
              ),
            },
            { text: formatMinutes(item.HORAS_VALIDADAS_OTRAS.toString()) },
            {
              text: formatMinutes(
                item.HORAS_PENDIENTES_VALIDAR_OTRAS.toString()
              ),
            },
          ],
        ],
      };
    });

    setData(cursosParsed);
  }, [cursos, allInformesCursosFilter]);

  if (
    !hasAccess(profileActive, [
      userProfile.gestor,
      userProfile.administrador,
      userProfile.formador,
      userProfile.alumno.extAspirante,
      userProfile.alumno.extBecario,
      userProfile.alumno.extMaquinista,
      userProfile.alumno.intBecario,
      userProfile.alumno.intMaquinista,
      userProfile.supervisor,
      userProfile.visualizador,
    ])
  ) {
    return <Redirect to={RouteTypes.HOME} push />;
  }

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  return (
    <>
      <Header />
      <div className="rf-layout-table rf-practice-list">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">
          Informes de Habilitaciones Infraestructura
        </h1>

        <ReportInfrastructureFilter handleSubmit={handleFilterChange} />

        <Table
          redirect={(e: any) => {
            redirect(e);
          }}
          list={false}
          data={data}
          dataCount={cursosCount}
          headers={headers}
          handleFilter={handleFilterTable}
          hideAudit={true}
          itemsOnLeft={3}
          handleExportExcel={handleExportExcel}
          pagination25={true}
        />
      </div>
      <RfUiModal
        title-modal={msgSubmit}
        modalConfirmText="Aceptar"
        id-modal="modalDraft"
        modal-type={modalDraftType}
        onModalClose={(e: any) => {
          dispatch(setMsgSubmit(''));
          dispatch(setModalDraftType(''));
        }}
        onConfirm={(e: any) => {
          dispatch(setMsgSubmit(''));
          dispatch(setModalDraftType(''));
        }}
      ></RfUiModal>
    </>
  );
};

export default Courses;
